import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const Phone = ()=>/*#__PURE__*/ _jsxs("svg", {
        width: "33",
        height: "32",
        viewBox: "0 0 33 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("title", {
                children: "phone-icon"
            }),
            /*#__PURE__*/ _jsxs("g", {
                clipPath: "url(#clip0_2847_1004)",
                children: [
                    /*#__PURE__*/ _jsx("path", {
                        d: "M19.4167 0.333252C18.8644 0.333252 18.4167 0.780967 18.4167 1.33325C18.4167 1.88554 18.8644 2.33325 19.4167 2.33325C25.4918 2.33325 30.4167 7.25812 30.4167 13.3333C30.4167 13.8855 30.8644 14.3333 31.4167 14.3333C31.9689 14.3333 32.4167 13.8855 32.4167 13.3333C32.4167 6.15355 26.5964 0.333252 19.4167 0.333252Z",
                        fill: "url(#paint0_linear_2847_1004)"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M12.6315 4.82621C12.5005 3.89284 12.0332 3.03896 11.3171 2.42402C10.601 1.80907 9.68488 1.47511 8.73991 1.48449H4.634C4.09466 1.48503 3.56133 1.59752 3.06795 1.81483C2.57458 2.03214 2.13197 2.3495 1.76829 2.74671C1.4046 3.14392 1.12781 3.61229 0.955532 4.122C0.78325 4.63172 0.719248 5.17162 0.7676 5.70735C1.23686 10.1134 2.7426 14.3467 5.16228 18.0628C7.3575 21.4992 10.2839 24.4118 13.7339 26.5942C17.4451 28.988 21.6667 30.482 26.0608 30.9565C26.601 31.0084 27.1461 30.9468 27.661 30.7759C28.1759 30.6049 28.6492 30.3284 29.0504 29.9639C29.4517 29.5995 29.772 29.1553 29.9907 28.66C30.2094 28.1647 30.3216 27.6292 30.3203 27.0879V22.9965C30.3672 21.0559 28.9279 19.3656 26.973 19.0936C25.7331 18.9302 24.5241 18.6308 23.361 18.1988L23.1226 18.1188C22.4528 17.9173 21.741 17.8994 21.0619 18.0669C20.3828 18.2344 19.7614 18.5812 19.2631 19.0708L18.1469 20.1805L18.0186 20.1016C15.4421 18.4722 13.2569 16.2969 11.6185 13.7302L11.5394 13.6045L12.6476 12.5016C13.172 11.9755 13.5339 11.3102 13.6901 10.5849C13.8464 9.85954 13.7904 9.10472 13.5288 8.41021C13.0949 7.25317 12.7939 6.05084 12.6315 4.82621ZM8.74984 3.48449H4.63517C4.3729 3.48486 4.11371 3.53963 3.87413 3.64516C3.63431 3.75078 3.41957 3.90487 3.24339 4.0973C3.06721 4.28971 2.93343 4.51626 2.85023 4.76241C2.76848 5.00428 2.73726 5.26007 2.75834 5.51414C3.19641 9.59953 4.59404 13.5248 6.83829 16.9715L6.84779 16.9861C8.88489 20.1749 11.6007 22.8782 14.8031 24.904L14.818 24.9135C18.2633 27.1357 22.1823 28.5239 26.2619 28.9666C26.5216 28.9901 26.7835 28.9599 27.0308 28.8778C27.2813 28.7946 27.5112 28.6602 27.7058 28.4834C27.9004 28.3067 28.0554 28.0916 28.1611 27.8522C28.2668 27.6128 28.3209 27.3542 28.3203 27.093L28.3203 27.0879L28.3203 22.9723L28.3208 22.9481C28.3429 22.0387 27.6613 21.2116 26.7031 21.0754C25.3297 20.8937 23.988 20.5625 22.6953 20.085L22.5215 20.0267C22.2021 19.9353 21.8639 19.929 21.5409 20.0087C21.2111 20.09 20.9098 20.2579 20.6682 20.4941L18.4409 22.7085L16.9606 21.7989L16.9496 21.792C14.1252 20.0058 11.7293 17.6209 9.93271 14.8063L9.92551 14.7951L8.99483 13.3153L11.2311 11.0896L11.2334 11.0873C11.4861 10.833 11.6599 10.5124 11.735 10.1638C11.8103 9.81409 11.7833 9.45018 11.6571 9.11513L11.6561 9.11241C11.1702 7.81651 10.8327 6.46993 10.6501 5.09832C10.5856 4.64982 10.3603 4.23859 10.0142 3.94136C9.66635 3.6427 9.2205 3.47982 8.75977 3.4844L8.74984 3.48449Z",
                        fill: "url(#paint1_linear_2847_1004)"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M17.0833 6.66659C17.0833 6.1143 17.531 5.66659 18.0833 5.66659C23.0539 5.66659 27.0833 9.69602 27.0833 14.6666C27.0833 15.2189 26.6356 15.6666 26.0833 15.6666C25.531 15.6666 25.0833 15.2189 25.0833 14.6666C25.0833 10.8006 21.9493 7.66659 18.0833 7.66659C17.531 7.66659 17.0833 7.21887 17.0833 6.66659Z",
                        fill: "url(#paint2_linear_2847_1004)"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("defs", {
                children: [
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint0_linear_2847_1004",
                        x1: "0.751953",
                        y1: "0.333252",
                        x2: "31.3765",
                        y2: "31.9809",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#311C77"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#FF2DFF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint1_linear_2847_1004",
                        x1: "0.751953",
                        y1: "0.333252",
                        x2: "31.3765",
                        y2: "31.9809",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#311C77"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#FF2DFF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint2_linear_2847_1004",
                        x1: "0.751953",
                        y1: "0.333252",
                        x2: "31.3765",
                        y2: "31.9809",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#311C77"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#FF2DFF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("clipPath", {
                        id: "clip0_2847_1004",
                        children: /*#__PURE__*/ _jsx("rect", {
                            width: "32",
                            height: "32",
                            fill: "white",
                            transform: "translate(0.75)"
                        })
                    })
                ]
            })
        ]
    });
